// extracted by mini-css-extract-plugin
export default {"title":"request-error-details_title__3CY3V"};